(function () {

    'use strict';

    angular.module('FotocApp')
 
    .component('tutorial', {
          
        templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH )  + 'editor/tutorial/tutorial.component.html',
        bindings: {
            start:'@'
        },
        controller: ['$scope','$tutorialService', '$editorService', '$lang', '$window', function ($scope, $tutorialService, $editorService, $lang, $window) {

            var self = this;
    
            this.$tutorialService = $tutorialService;
            this.$editorService = $editorService;
            $scope.$lang =  $lang;

            this.$onInit = function () {
                if(this.start === 'gallery'){
                    $editorService.ui.imagesTabActive =  "stock";
                } else {
                    $tutorialService.changeStartTuto();
                    $editorService.ui.imagesTabActive =  "my_galery";
                }
            }

            this.next = function(){
                var _next = $tutorialService.inSlide  + 1;
                if(_next>=$tutorialService.tuto.length){
                    $tutorialService.close();
                }else{
                    $tutorialService.inSlide = _next;
                }
            }

            this.close = function(){
                $tutorialService.close();
            }


        }]
    })
})();